import { render, staticRenderFns } from "./Home-Request.vue?vue&type=template&id=1d63fea7&scoped=true&"
import script from "./Home-Request.vue?vue&type=script&lang=js&"
export * from "./Home-Request.vue?vue&type=script&lang=js&"
import style0 from "./Home-Request.vue?vue&type=style&index=0&id=1d63fea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63fea7",
  null
  
)

export default component.exports